import { Loader2, ArrowRight } from "lucide-react";
import NameSuggester from "@/sections/NameSuggester";
import VibeTemplates from "@/pages/create/VibeTemplates";

const THEMES = [
  { id: "meme", label: "Meme", color: "#FF3E9D" },
  { id: "utility", label: "Utility", color: "#00D4FF" },
  { id: "gaming", label: "Gaming", color: "#A855F7" },
  { id: "ai", label: "AI", color: "#CFFF04" },
  { id: "defi", label: "DeFi", color: "#FFD700" },
];

const fmtSupply = (n) => Number(n || 0).toLocaleString();

export default function StepBasics({ form, setForm, submitBusy, submitDraft }) {
  return (
    <div data-testid="step-0">
      <h1 className="font-display font-black text-4xl sm:text-5xl uppercase tracking-tighter mb-3">
        Name your coin.
      </h1>
      <p className="text-[#e2e2e2] mb-8">
        You can change everything later. Free to draft, $19 to publish, $49 to feature.
      </p>

      <VibeTemplates setForm={setForm} />

      <div className="space-y-5">
        <div>
          <label className="font-mono text-xs uppercase tracking-widest text-[#e2e2e2] block mb-2">
            Coin name
          </label>
          <input
            data-testid="coin-name"
            value={form.name}
            onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
            placeholder="e.g. Cosmic Otter"
            maxLength={40}
            className="w-full bg-[#121212] border border-[#3d3d3d] focus:border-[#cfff04] focus:outline-none placeholder:text-[#b8b8b8] px-4 py-4 font-display text-2xl"
          />
          <NameSuggester
            theme={form.theme}
            onPick={(n) =>
              setForm((f) => ({
                ...f,
                name: n.name,
                ticker: n.ticker.toUpperCase().slice(0, 8),
                description: f.description || n.tagline,
              }))
            }
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="font-mono text-xs uppercase tracking-widest text-[#e2e2e2] block mb-2">
              Ticker
            </label>
            <input
              data-testid="coin-ticker"
              value={form.ticker}
              onChange={(e) =>
                setForm((f) => ({ ...f, ticker: e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 8) }))
              }
              placeholder="OTTER"
              className="w-full bg-[#121212] border border-[#3d3d3d] focus:border-[#cfff04] focus:outline-none placeholder:text-[#b8b8b8] px-4 py-4 font-mono text-xl uppercase"
            />
          </div>
          <div>
            <label className="font-mono text-xs uppercase tracking-widest text-[#e2e2e2] block mb-2">
              Total supply
            </label>
            <input
              data-testid="coin-supply"
              type="text"
              inputMode="numeric"
              value={form.supply}
              onChange={(e) => setForm((f) => ({ ...f, supply: e.target.value }))}
              className="w-full bg-[#121212] border border-[#3d3d3d] focus:border-[#cfff04] focus:outline-none placeholder:text-[#b8b8b8] px-4 py-4 font-mono text-xl"
            />
            <div className="text-sm text-[#c4c4c4] mt-1">
              = {fmtSupply(form.supply)}
            </div>
          </div>
        </div>

        <div>
          <label className="font-mono text-xs uppercase tracking-widest text-[#e2e2e2] block mb-2">
            Theme
          </label>
          <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
            {THEMES.map((t) => (
              <button
                key={t.id}
                onClick={() => setForm((f) => ({ ...f, theme: t.id }))}
                data-testid={`theme-${t.id}`}
                className={`border p-4 text-left transition-all ${
                  form.theme === t.id
                    ? "border-[#cfff04] bg-[#121212]"
                    : "border-[#3a3a3a] bg-[#121212] hover:border-[#444]"
                }`}
              >
                <span className="block w-3 h-3 mb-3" style={{ background: t.color }} />
                <span className="font-display text-sm font-bold uppercase">{t.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="font-mono text-xs uppercase tracking-widest text-[#e2e2e2] block mb-2">
            Short pitch (optional)
          </label>
          <textarea
            data-testid="coin-description"
            value={form.description}
            onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))}
            rows={3}
            maxLength={300}
            placeholder="What's the joke? The mission? The vibe?"
            className="w-full bg-[#121212] border border-[#3d3d3d] focus:border-[#cfff04] focus:outline-none placeholder:text-[#b8b8b8] px-4 py-3 text-sm"
          />
        </div>
      </div>

      <div className="mt-8 flex justify-end">
        <button
          onClick={submitDraft}
          disabled={submitBusy}
          data-testid="create-next"
          className="btn-brutal bg-[#cfff04] text-[#050505] font-bold uppercase tracking-wider text-sm px-8 py-4 flex items-center gap-2"
        >
          {submitBusy ? <Loader2 size={16} className="animate-spin" /> : <ArrowRight size={16} />}
          Next: AI Logo
        </button>
      </div>
    </div>
  );
}
